import { render } from "./ImplantsGuideAfterSurgery.vue?vue&type=template&id=0aec0862"
import script from "./ImplantsGuideAfterSurgery.vue?vue&type=script&lang=js"
export * from "./ImplantsGuideAfterSurgery.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__